import { ValueType } from "pokal_api"

export const valueTypeNames: Record<ValueType, string> = {
    [ValueType.PHQUESTIONNAIRE]: "PHQ-8 Fragebogen",
    [ValueType.SFQUESTIONNAIRE]: "SFQ Fragen",
    [ValueType.MOOD]: "Stimmungserfassung",
    [ValueType.SLEEP_DURATION]: "Schlafdauer",
    [ValueType.SLEEP_LATENCY]: "Einschlafdauer",
    [ValueType.SLEEP_HEART_RATE]: "Herzfrequenz bei Nacht",
    [ValueType.SLEEP_HEART_RATE_VARIABILITY]: "Herzfrequenzvariabilität bei Nacht",
    [ValueType.STEPS]: "Schrittzahl"
}

export const valueTypeShortNames: Record<ValueType, string> = {
    [ValueType.PHQUESTIONNAIRE]: "PHQ-8",
    [ValueType.SFQUESTIONNAIRE]: "SF",
    [ValueType.MOOD]: "Stimmung",
    [ValueType.SLEEP_DURATION]: "Schlafdauer",
    [ValueType.SLEEP_LATENCY]: "Schlaflatenz",
    [ValueType.SLEEP_HEART_RATE]: "Schlaf-HF",
    [ValueType.SLEEP_HEART_RATE_VARIABILITY]: "Schlaf-HRV",
    [ValueType.STEPS]: "Schritte"
}
